import { ConnectFileError } from 'src/app/shared/map-data-services/mapWorkspace/map-workspace';

export enum ShareMode {
    PUBLIC_USER = 'PUBLIC',
    SIGNED_IN_USER = 'REGISTERED_USERS',
    PROJECT_USER = 'PROJECT_USERS',
    NONE = 'NONE'
}

export enum ShareTokenPermission {
    VIEW = 'VIEW',
    DOWNLOAD = 'DOWNLOAD'
}

export const ACCESS_MODE_KEY = 'accessMode';
export const SHARED_TOKEN_KEY = 'sharedToken';
export const SHARED_MODE_KEY = 'shareMode';
export const HEADER_WORKSPACE_TYPE = 'X-Field-Data-Viewer-Workspace-Type';

export enum AccessMode {
    BEARER = 'Bearer',
    SHARED = 'Shared'
}

export interface ShareToken {
    id: string;
    projectId: string;
    mode: ShareMode;
    permission: ShareTokenPermission;
    objects: {
        id: string;
        type: string;
        url: string;
        useLatestVersion: boolean;
    }[];
    shareToken: string;
    accessToken: string;
}

export const SharedWorkspaceDTOParams = {
    id: 'SHARED_WS_ID',
    name: 'FILEVIEWER',
    uuid: '55555555-5555-5555-5555-555555555555',
    connectFileError: ConnectFileError.PERMISSION_DENIED
};
